/**
 * The banner every surface *Spis k dátumu* applies to shows while a date is set (PRD-0075 R-D4):
 * the dashboard, an entity's History and the hypotheses. It says which day the file is shown as
 * of and, given `onClear`, takes the reader back to today.
 */
import { CalendarClock, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { cn } from '@/utils/cn'
import { formatAsOfDay } from './as-of-day'

export interface AsOfBannerProps {
  /** `YYYY-MM-DD`. */
  day: string
  onClear?: (() => void) | null
  className?: string
}

export function AsOfBanner({ day, onClear, className }: AsOfBannerProps) {
  const { t, i18n } = useTranslation()
  return (
    <div
      role="status"
      className={cn(
        'flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-warning/40 bg-warning/10 px-3 py-2',
        className
      )}
    >
      <CalendarClock aria-hidden className="size-4 shrink-0 text-warning" />
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="text-sm font-medium text-foreground">
          {t('caseAsOf.banner', { date: formatAsOfDay(day, i18n.language) })}
        </span>
        <span className="text-xs text-muted-foreground">{t('caseAsOf.bannerHint')}</span>
      </div>
      {onClear ? (
        <Button variant="ghost" size="xs" onClick={onClear}>
          <X aria-hidden />
          {t('caseAsOf.clear')}
        </Button>
      ) : null}
    </div>
  )
}
